<template>
  <div class="verify-dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="600px"
      title="用户认证"
      @close="handleClose"
      z-index="999999"
    >
      <div class="verify-type">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane label="企业认证" name="company">
            <div class="verify-form">
              <p class="verify-tip">请上传企业营业执照或对公付款单图片</p>

              <el-form :model="companyForm" ref="companyForm" label-width="120px">
                <el-form-item label="公司全称" required>
                  <el-input v-model="companyForm.company_name" placeholder="请输入公司全称"></el-input>
                </el-form-item>

                <el-form-item label="营业执照/对公付款单" required>
                  <el-upload
                    class="upload-demo"
                    action="https://api.kol.cn/api/ueditor?action=uploadimage"
                    :on-change="handleCompanyFileChange"
                    :on-remove="handleCompanyFileRemove"
                    :before-upload="handleBeforeUpload"
                    :file-list="companyFileList"
                    :limit="1"
                    accept="image/*"
                    :with-credentials="true"
                    name="upfile"
                    :auto-upload="false"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传 jpg/png 文件，且不超过 3MB</div>
                  </el-upload>
                  <div v-if="companyImageUrl" class="image-preview">
                    <img :src="companyImageUrl" alt="营业执照预览" class="preview-img" />
                    <div class="preview-actions">
                      <el-button type="text" size="small" @click="previewImage(companyImageUrl)">
                        <i class="el-icon-zoom-in"></i> 查看大图
                      </el-button>
                      <el-button type="text" size="small" @click="removeCompanyImage">
                        <i class="el-icon-delete"></i> 删除
                      </el-button>
                    </div>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>

          <el-tab-pane label="个人认证" name="personal">
            <div class="verify-form">
              <p class="verify-tip">请上传身份证正反面照片</p>
              <el-form :model="personalForm" ref="personalForm" label-width="120px">
                <el-form-item label="姓名" required>
                  <el-input v-model="personalForm.name" placeholder="请输入姓名"></el-input>
                </el-form-item>

                <el-form-item label="身份证号码" required>
                  <el-input v-model="personalForm.id_card" placeholder="请输入身份证号码"></el-input>
                </el-form-item>

                <el-form-item label="身份证正面" required>
                  <el-upload
                    class="upload-demo"
                    action="https://api.kol.cn/api/ueditor?action=uploadimage"
                    :on-change="handleFrontFileChange"
                    :on-remove="handleFrontFileRemove"
                    :before-upload="handleBeforeUpload"
                    :file-list="frontFileList"
                    :limit="1"
                    accept="image/*"
                    :with-credentials="true"
                    name="upfile"
                    :auto-upload="false"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传 jpg/png 文件，且不超过 3MB</div>
                  </el-upload>
                  <div v-if="frontImageUrl" class="image-preview">
                    <img :src="frontImageUrl" alt="身份证正面预览" class="preview-img" />
                    <div class="preview-actions">
                      <el-button type="text" size="small" @click="previewImage(frontImageUrl)">
                        <i class="el-icon-zoom-in"></i> 查看大图
                      </el-button>
                      <el-button type="text" size="small" @click="removeFrontImage">
                        <i class="el-icon-delete"></i> 删除
                      </el-button>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="身份证反面" required>
                  <el-upload
                    class="upload-demo"
                    action="https://api.kol.cn/api/ueditor?action=uploadimage"
                    :on-change="handleBackFileChange"
                    :on-remove="handleBackFileRemove"
                    :before-upload="handleBeforeUpload"
                    :file-list="backFileList"
                    :limit="1"
                    accept="image/*"
                    :with-credentials="true"
                    name="upfile"
                    :auto-upload="false"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传 jpg/png 文件，且不超过 3MB</div>
                  </el-upload>
                  <div v-if="backImageUrl" class="image-preview">
                    <img :src="backImageUrl" alt="身份证反面预览" class="preview-img" />
                    <div class="preview-actions">
                      <el-button type="text" size="small" @click="previewImage(backImageUrl)">
                        <i class="el-icon-zoom-in"></i> 查看大图
                      </el-button>
                      <el-button type="text" size="small" @click="removeBackImage">
                        <i class="el-icon-delete"></i> 删除
                      </el-button>
                    </div>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserVerify',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    defaultType: {
      type: String,
      default: 'company',
      validator: value => ['company', 'personal'].includes(value)
    }
  },
  data() {
    return {
      dialogVisible: false,
      activeTab: 'company',
      submitting: false,
      companyForm: {
        company_name: '',
        verify_type: 'company'
      },
      personalForm: {
        name: '',
        id_card: '',
        verify_type: 'personal'
      },
      companyFileList: [],
      frontFileList: [],
      backFileList: [],
      companyFile: null,
      frontFile: null,
      backFile: null,
      companyImageUrl: '',
      frontImageUrl: '',
      backImageUrl: ''
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.activeTab = this.defaultType;
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
      if (!val) {
        this.resetForm();
      }
    },
    defaultType(val) {
      if (this.dialogVisible) {
        this.activeTab = val;
      }
    }
  },
  methods: {
    // 上传前验证文件大小
    handleBeforeUpload(file) {
      const maxSize = 3 * 1024 * 1024; // 3MB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过 3MB');
        return false; // 阻止上传
      }
      return true; // 允许上传
    },

    addWatermarkToImage(file, watermarkText) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0);

            ctx.font = 'bold 28px Arial';
            ctx.fillStyle = 'rgba(0, 0, 0, 0.4)';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            const stepX = 200;
            const stepY = 150;

            for (let x = 100; x < canvas.width; x += stepX) {
              for (let y = 100; y < canvas.height; y += stepY) {
                ctx.save();
                ctx.translate(x, y);
                ctx.rotate(-Math.PI / 6);
                ctx.fillText(watermarkText, 0, 0);
                ctx.restore();
              }
            }

            canvas.toBlob((blob) => {
              if (blob) {
                const watermarkedFile = new File([blob], file.name, {
                  type: file.type,
                  lastModified: Date.now()
                });
                resolve(watermarkedFile);
              } else {
                reject(new Error('水印处理失败'));
              }
            }, file.type, 0.9);
          };
          img.onerror = reject;
          img.src = e.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    compressImageIfNeeded(file, maxWidth = 900) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            let width = img.width;
            let height = img.height;

            if (width <= maxWidth && height <= maxWidth) {
              resolve(file);
              return;
            }

            if (width > height) {
              height = Math.round((height * maxWidth) / width);
              width = maxWidth;
            } else {
              width = Math.round((width * maxWidth) / height);
              height = maxWidth;
            }

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob((blob) => {
              if (blob) {
                const compressedFile = new File([blob], file.name, {
                  type: file.type,
                  lastModified: Date.now()
                });
                resolve(compressedFile);
              } else {
                reject(new Error('图片压缩失败'));
              }
            }, file.type, 0.9);
          };
          img.onerror = reject;
          img.src = e.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    handleTabClick(tab) {
      this.activeTab = tab.name;
    },

    async handleCompanyFileChange(file, fileList) {
      this.companyFileList = fileList.slice(0, 1);

      try {
        let processedFile = file.raw;

        processedFile = await this.compressImageIfNeeded(processedFile, 800);

        const watermarkText = `软文街认证专用 ${new Date().toLocaleDateString()}`;
        processedFile = await this.addWatermarkToImage(processedFile, watermarkText);

        this.companyFile = processedFile;
        this.uploadWithWatermark(processedFile, 'company');
      } catch (err) {
        console.error('图片处理失败:', err);
        this.companyFile = file.raw;
        this.$message.warning('图片处理失败，将上传原图');
      }
    },

    uploadWithWatermark(file, type) {
      const formData = new FormData();
      formData.append('upfile', file);

      this.$http.post('https://api.kol.cn/api/ueditor?action=uploadimage', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }).then(response => {
        if (response.state === 'SUCCESS') {
          if (type === 'company') {
            this.companyImageUrl = response.url;
            this.$message.success('营业执照上传成功');
          } else if (type === 'front') {
            this.frontImageUrl = response.url;
            this.$message.success('身份证正面上传成功');
          } else if (type === 'back') {
            this.backImageUrl = response.url;
            this.$message.success('身份证反面上传成功');
          }
        } else {
          this.$message.error('上传失败，文件大小不能超过 3MB');
        }
      }).catch(() => {
        this.$message.error('上传失败，文件大小不能超过 3MB');
      });
    },

    handleCompanyFileRemove(file, fileList) {
      this.companyFileList = fileList;
      this.companyFile = null;
      this.companyImageUrl = '';
    },
    removeCompanyImage() {
      this.companyFileList = [];
      this.companyFile = null;
      this.companyImageUrl = '';
    },

    async handleFrontFileChange(file, fileList) {
      this.frontFileList = fileList.slice(0, 1);

      try {
        let processedFile = file.raw;

        processedFile = await this.compressImageIfNeeded(processedFile, 800);

        const watermarkText = `软文街认证专用 ${new Date().toLocaleDateString()}`;
        processedFile = await this.addWatermarkToImage(processedFile, watermarkText);

        this.frontFile = processedFile;
        this.uploadWithWatermark(processedFile, 'front');
      } catch (err) {
        console.error('图片处理失败:', err);
        this.frontFile = file.raw;
        this.$message.warning('图片处理失败，将上传原图');
      }
    },

    handleFrontFileRemove(file, fileList) {
      this.frontFileList = fileList;
      this.frontFile = null;
      this.frontImageUrl = '';
    },

    removeFrontImage() {
      this.frontFileList = [];
      this.frontFile = null;
      this.frontImageUrl = '';
    },

    async handleBackFileChange(file, fileList) {
      this.backFileList = fileList.slice(0, 1);

      try {
        let processedFile = file.raw;

        processedFile = await this.compressImageIfNeeded(processedFile, 800);

        const watermarkText = `软文街认证专用 ${new Date().toLocaleDateString()}`;
        processedFile = await this.addWatermarkToImage(processedFile, watermarkText);

        this.backFile = processedFile;
        this.uploadWithWatermark(processedFile, 'back');
      } catch (err) {
        console.error('图片处理失败:', err);
        this.backFile = file.raw;
        this.$message.warning('图片处理失败，将上传原图');
      }
    },

    handleBackFileRemove(file, fileList) {
      this.backFileList = fileList;
      this.backFile = null;
      this.backImageUrl = '';
    },

    removeBackImage() {
      this.backFileList = [];
      this.backFile = null;
      this.backImageUrl = '';
    },

    handleSubmit() {
      if (this.activeTab === 'company') {
        if (!this.companyForm.company_name) {
          this.$message.error('请输入公司全称');
          return;
        }
        if (!this.companyImageUrl) {
          this.$message.error('请上传营业执照或对公付款单');
          return;
        }

        this.submitCompanyVerify();
      } else {
        if (!this.personalForm.name) {
          this.$message.error('请输入姓名');
          return;
        }
        if (!this.personalForm.id_card || !this.validateIdCard(this.personalForm.id_card)) {
          this.$message.error('请输入正确的身份证号码');
          return;
        }
        if (!this.frontImageUrl || !this.backImageUrl) {
          this.$message.error('请上传身份证正反面照片');
          return;
        }

        this.submitPersonalVerify();
      }
    },

    submitCompanyVerify() {
      this.submitting = true;

      this.$http
        .post('/personal/verify', {
          verify_type: 'company',
          company_name: this.companyForm.company_name,
          license_image: this.companyImageUrl
        })
        .then(response => {
          if (response.success) {
            this.$alert('认证申请已提交，请耐心等待审核', '提交成功', {
              confirmButtonText: '确定',
              type: 'success'
            }).then(() => {
              this.dialogVisible = false;
              this.$emit('submitted');
            });
          } else {
            this.$message.error(response.message || '提交失败');
          }
        })
        .catch(error => {
          this.$message.error('提交失败，请稍后重试');
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    submitPersonalVerify() {
      this.submitting = true;

      this.$http
        .post('/personal/verify', {
          verify_type: 'personal',
          name: this.personalForm.name,
          id_card: this.personalForm.id_card,
          id_card_front: this.frontImageUrl,
          id_card_back: this.backImageUrl
        })
        .then(response => {
          if (response.success) {
            this.$alert('认证申请已提交，请耐心等待审核', '提交成功', {
              confirmButtonText: '确定',
              type: 'success'
            }).then(() => {
              this.dialogVisible = false;
              this.$emit('submitted');
            });
          } else {
            this.$message.error(response.message || '提交失败');
          }
        })
        .catch(error => {
          this.$message.error('提交失败，请稍后重试');
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    validateIdCard(idCard) {
      const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return reg.test(idCard);
    },
    previewImage(url) {
      window.open(url, '_blank');
    },
    handleClose() {
      this.resetForm();
    },

    resetForm() {
      this.companyForm = {
        company_name: '',
        verify_type: 'company'
      };
      this.personalForm = {
        name: '',
        id_card: '',
        verify_type: 'personal'
      };
      this.companyFileList = [];
      this.frontFileList = [];
      this.backFileList = [];
      this.companyFile = null;
      this.frontFile = null;
      this.backFile = null;
      this.activeTab = 'company';

      if (this.$refs.companyForm) {
        this.$refs.companyForm.clearValidate();
      }
      if (this.$refs.personalForm) {
        this.$refs.personalForm.clearValidate();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.verify-dialog {

  .verify-type {
    padding: 20px 0;

    .verify-form {
      padding: 10px;

      .verify-tip {
        font-size: 14px;
        color: #909399;
        margin-bottom: 20px;
        line-height: 1.5;
      }

      /deep/ .el-form-item {
        margin-bottom: 22px;
      }

      /deep/ .el-input {
        width: 100%;
      }

      /deep/ .el-upload__tip {
        font-size: 12px;
        color: #909399;
        margin-top: 5px;
      }
      .image-preview {
        margin-top: 10px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        padding: 10px;
        background-color: #f5f7fa;

        .preview-img {
          width: 100%;
          max-width: 300px;
          max-height: 200px;
          object-fit: contain;
          border-radius: 4px;
          cursor: pointer;
          display: block;
          margin-bottom: 8px;

          &:hover {
            opacity: 0.8;
            transition: opacity 0.3s;
          }
        }

        .preview-actions {
          display: flex;
          gap: 10px;
          justify-content: flex-start;

          /deep/ .el-button {
            padding: 5px 10px;

            i {
              margin-right: 4px;
            }
          }
        }
      }
    }
  }

  /deep/ .el-tabs__item {
    font-size: 15px;
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/auth/UserVerify.vue